import { ActionClient } from '@/api/client/action'
import { AttachmentClient } from '@/api/client/attachment'
import { BranchClient } from '@/api/client/branch'
import { BranchTargetClient } from '@/api/client/branch-target'
import { BrandingClient } from '@/api/client/branding'
import { ChecklistSettingsClient } from '@/api/client/checklist-settings'
import { CommentClient } from '@/api/client/comment'
import { CompanyClient } from '@/api/client/company'
import { ContactClient } from '@/api/client/contact'
import { CredentialsClient } from '@/api/client/credentials'
import { MentionClient } from '@/api/client/mention'
import { ProjectClient } from '@/api/client/project'
import { ReferralClient } from '@/api/client/referral'
import { ReferralNodeClient } from '@/api/client/referral-node'
import { RealworksCredentialsClient } from '@/api/client/realworks-credentials'
import { UserClient } from '@/api/client/user'
import { UserTargetClient } from '@/api/client/user-target'
import { EventLogClient } from '@/api/client/event-log'
import { TriggeredActionClient } from '@/api/client/triggered-action'
import { TriggeredReferralClient } from '@/api/client/triggered-referral'
import { RealworksKenmerkClient } from '@/api/client/realworks-kenmerk'
import { ScheduledDashboardExportClient } from '@/api/client/scheduled-dashboard-export'
import { ShareClient } from '@/api/client/share'
import { DashboardClient } from '@/api/client/dashboard'
import { OrderClient } from '@/api/client/order'
import { PrintableDocumentClient } from '@/api/client/printable-document'
import { PrintedDocumentClient } from '@/api/client/printed-document'
import { RealworksStatusRuleClient } from '@/api/client/realworks-status-rule'
import { ReferralCountClient } from '@/api/client/referral-count'
import { OrderCountClient } from '@/api/client/order-count'
import { WebhookClient } from '@/api/client/webhook'
import { GamificationSettingsClient } from '@/api/client/gamification-settings'
import { GamificationBadgeClient } from '@/api/client/gamification-badge'
import { GamificationScoreClient } from '@/api/client/gamification-score'
import { TypeformFormClient } from '@/api/client/typeform-form'
import { TypeformResponseClient } from '@/api/client/typeform-response'
import { CustomerPortalBrandingClient } from '@/api/client/customer-portal-branding'
import { CustomerPortalLinkClient } from '@/api/client/customer-portal-link'
import { TypeformResponseAnswerHookClient } from '@/api/client/typeform-response-answer-hook'
import { PipelineClient } from '@/api/client/pipeline'
import { PipelinePhaseClient } from '@/api/client/pipeline-phase'
import { PipelineConnectionClient } from '@/api/client/pipeline-connection'
import { StatusClient } from '@/api/client/status'
import { StatusReasonClient } from '@/api/client/status-reason'
import { BranchOperatingZoneClient } from '@/api/client/branch-operating-zone'
import { MigrationMapClient } from '@/api/client/migration-map'
import { SourceClient } from '@/api/client/source'
import { LicenseClient } from '@/api/client/license'
import { RealworksProductClient } from '@/api/client/realworks-product'

export const ActionAPI = new ActionClient()
export const AttachmentAPI = new AttachmentClient()
export const BranchAPI = new BranchClient()
export const BranchOperatingZoneAPI = new BranchOperatingZoneClient()
export const BranchTargetAPI = new BranchTargetClient()
export const BrandingAPI = new BrandingClient()
export const ChecklistSettingsAPI = new ChecklistSettingsClient()
export const CommentAPI = new CommentClient()
export const CompanyAPI = new CompanyClient()
export const ContactAPI = new ContactClient()
export const CredentialsAPI = new CredentialsClient()
export const MentionAPI = new MentionClient()
export const ProjectAPI = new ProjectClient()
export const RealworksCredentialsAPI = new RealworksCredentialsClient()
export const ReferralAPI = new ReferralClient()
export const ReferralCountAPI = new ReferralCountClient()
export const ReferralNodeAPI = new ReferralNodeClient()
export const UserAPI = new UserClient()
export const UserTargetAPI = new UserTargetClient()
export const EventLogAPI = new EventLogClient()
export const TriggeredActionAPI = new TriggeredActionClient()
export const TriggeredReferralAPI = new TriggeredReferralClient()
export const RealworksProductAPI = new RealworksProductClient()
export const RealworksKenmerkAPI = new RealworksKenmerkClient()
export const ScheduledDashboardExportAPI = new ScheduledDashboardExportClient()
export const ShareAPI = new ShareClient()
export const DashboardAPI = new DashboardClient()
export const OrderAPI = new OrderClient()
export const OrderCountAPI = new OrderCountClient()
export const PrintableDocumentAPI = new PrintableDocumentClient()
export const PrintedDocumentAPI = new PrintedDocumentClient()
export const RealworksStatusRuleAPI = new RealworksStatusRuleClient()
export const WebhookAPI = new WebhookClient()
export const GamificationSettingsAPI = new GamificationSettingsClient()
export const GamificationBadgeAPI = new GamificationBadgeClient()
export const GamificationScoreAPI = new GamificationScoreClient()
export const TypeformFormAPI = new TypeformFormClient()
export const TypeformResponseAPI = new TypeformResponseClient()
export const TypeformResponseAnswerHookAPI = new TypeformResponseAnswerHookClient()
export const CustomerPortalBrandingAPI = new CustomerPortalBrandingClient()
export const CustomerPortalLinkAPI = new CustomerPortalLinkClient()
export const PipelineAPI = new PipelineClient()
export const PipelinePhaseAPI = new PipelinePhaseClient()
export const PipelineConnectionAPI = new PipelineConnectionClient()
export const StatusAPI = new StatusClient()
export const StatusReasonAPI = new StatusReasonClient()
export const MigrationMapAPI = new MigrationMapClient()
export const SourceAPI = new SourceClient()
export const LicenseAPI = new LicenseClient()
